import { SidebarContent } from "../sidebar/SidebarContent";

interface HeaderProps {
  className?: string;
}

export function StandardHeader({ className }: HeaderProps) {
  return (
    <header
      className={`top-0 flex flex-col items-center justify-center lg:sticky lg:h-dvh ${className}`}
    >
      <SidebarContent />
    </header>
  );
}
